<template>
    <div>
        <v-card>
            <v-card-title style="margin-bottom: 20px;" class="font-weight-black black--text text">
                {{$t("languagePreferences")}}
            </v-card-title>
            <v-card-subtitle class="black--text">
                {{ $t('pleaseChoosePreferedLanguage') }}
            </v-card-subtitle>
                <v-card flat>
                    <v-card-text>
                        <v-row>
                            <v-col
                                cols="6"
                                sm="6"
                            >
                                <label class="subtitle-1 font-weight-medium black--text" for="Select Language">{{ $t('user.selectLanguage') }}</label>
                                <div class="d-flex">
                                    <v-select
                                        :items="langData"
                                        item-text="name"
                                        item-value="value"
                                        outlined
                                        dense
                                        class="shrink mr-2 wdt"
                                        v-model="lang"
                                    ></v-select>
                                </div>
                                
                            </v-col>
                        </v-row>
                                
                    </v-card-text>
                </v-card>
                
                <v-card-title class="font-weight-black black--text text">
                    {{ $t('user.unitPreference') }}
                </v-card-title>
                <!-- <v-card-subtitle class="black--text">
                    Please choose your preferred language.
                </v-card-subtitle> -->
                <v-card flat>
                            <v-card-text>
                                <v-row>
                                    <v-col
                                        cols="6"
                                        sm="6"
                                    >
                                        <label class="subtitle-1 font-weight-medium black--text" for="Select Language">{{ $t('user.selectUnitOfMeasure') }}</label>
                                        <div class="d-flex">
                                            <v-select
                                                :items="weightUnits"
                                                item-text="name"
                                                item-value="value"
                                                outlined
                                                dense
                                                class="shrink mr-2 wdt"
                                                v-model="units"
                                            ></v-select>
                                        </div>
                                    </v-col>
                                </v-row>
                                        
                            </v-card-text>
                        </v-card>
                        <v-divider />
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        width="116"
                        height="44"
                        class="ml-2"
                        outlined
                        color="primary"
                        exact
                        >{{ $t("cancel") }}</v-btn
                    >
                    <v-btn class="mt-4 mb-4" @click="updatePassword" right height="44" width="116" color="primary">
                        {{$t('update')}}
                    </v-btn>
                </v-card-actions>
            
        </v-card>
    </div>
</template>
<script>
import loading from "@/mixins/LoadingMixin";
import UserService from "@/_services/UserService";

export default {
    mounted() {
		this.getSettings();
	},
    data: () => ({
        lang: '',
        units: '',
        langData: [{name: 'English', value: 'en'},
            {name: 'Hindi', value: 'hi'}],
        weightUnits: [
            {name: 'kg', value: 'KG'},
            {name: 'lbs', value: 'LBS'}
        ],
        user: {
            currentPassword: '',
            newPassword: '',
            newPasswordConfirm: '',
        },
    }),
    methods: {
        updatePassword() {
            console.log(this.units, this.lang)
            const set = {
                "language": this.lang,
                "weightUnit": this.units
            }
            UserService.updateSettings(set)
            .then(res => {
                if(res.code == 200){
                    this.$notify({
                        title: 'Updated',
                        text: res.message,
                        type: 'success'
                    })
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        getSettings(){
            UserService.getSettings()
            .then(res => {
                this.lang = res.data.language
                this.units = res.data.weightUnit
            })
            .catch(err => {
                console.log(err)
            })
        }
    },
    mixins: [loading]
}
</script>
<style lang="scss">
.v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
    padding: 4px 0 10px 0;
}

.text{
    font-weight: 700;
    font-size: 22px;
    line-height: 38px;
}

.v-select.v-text-field--outlined:not(.v-text-field--single-line) .v-select__selections {
    width: 264px;
}
.v-select__selections {
    align-items: center;
    display: flex;
    flex: 1 1;
    flex-wrap: wrap;
    line-height: 21px;
    max-width: 100%;
    min-width: 0;
}
</style>
